'use client'
import { CardBody as ChakraCardBody } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { CardBodyProps } from './CardBody.types'

export default forwardRef(function CardBody(
  props: CardBodyProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraCardBody {...props} ref={ref} translate="no" />
})
